module.exports = __webpack_public_path__ + "static/media/ar_letter.58e736e4.png";